"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenu = void 0;
var react_1 = __importStar(require("react"));
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var nestedMenuItemsFromObject_1 = require("./nestedMenuItemsFromObject");
var ContextMenu = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var children = _a.children, menuItems = _a.menuItems, menuItemsData = _a.menuItemsData;
    var wrapperRef = (_b = ref) !== null && _b !== void 0 ? _b : (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(null), menuPosition = _c[0], setMenuPosition = _c[1];
    var _d = (0, react_1.useState)(null), mouseDownPosition = _d[0], setMouseDownPosition = _d[1];
    var handleItemClick = function () { return setMenuPosition(null); };
    var handleMouseDown = function (e) {
        if (menuPosition !== null)
            setMenuPosition(null);
        if (e.button !== 2)
            return;
        var wrapperBounds = wrapperRef.current.getBoundingClientRect();
        // Check mouse coordinates are inside the rect
        if (e.clientX < wrapperBounds.left ||
            e.clientX > wrapperBounds.right ||
            e.clientY < wrapperBounds.top ||
            e.clientY > wrapperBounds.bottom) {
            return;
        }
        setMouseDownPosition({ top: e.clientY, left: e.clientX });
    };
    var handleMouseUp = function (e) {
        var top = e.clientY;
        var left = e.clientX;
        if (mouseDownPosition === null)
            return;
        if (mouseDownPosition.top === top && mouseDownPosition.left === left) {
            setMenuPosition({ top: e.clientY, left: e.clientX });
        }
    };
    var menuContents = menuItems !== null && menuItems !== void 0 ? menuItems : (menuItemsData &&
        (0, nestedMenuItemsFromObject_1.nestedMenuItemsFromObject)({
            menuItemsData: menuItemsData,
            isOpen: !!menuPosition,
            handleClose: handleItemClick,
        }));
    return (react_1.default.createElement("div", { ref: wrapperRef, onContextMenu: function (e) { return e.preventDefault(); }, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp },
        react_1.default.createElement(Menu_1.default, { onContextMenu: function (e) { return e.preventDefault(); }, open: !!menuPosition, onClose: function () { return setMenuPosition(null); }, anchorReference: "anchorPosition", anchorPosition: menuPosition }, menuContents),
        children));
});
exports.ContextMenu = ContextMenu;
ContextMenu.displayName = 'ContextMenu';
